import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Col, Container, Row } from 'reactstrap';
import logo from '../../../assets/img/404.png';
class Page404 extends Component {


  constructor(props) {
    super(props);
    this.state = {
      login: false,
      home: false,
      contact: false,
    };
    this.renderRedirect = this.renderRedirect.bind(this);
    this.toggleHome = this.toggleHome.bind(this);
    this.toggleContact = this.toggleContact.bind(this);
    this.toggleLogin = this.toggleLogin.bind(this);
  }

  renderRedirect = () => {
    if (this.state.login) {
      return <Redirect to= { '/login/'} />
    }
    if (this.state.home) {
      return <Redirect to= { '/home'} />
    }
    if (this.state.contact) {
      return <Redirect to= { '/contact'} />
    }
  }

  toggleHome() {
    this.setState({home : true});
  } 

  toggleContact() {
    this.setState({contact : true});
  } 

  toggleLogin() {
    this.setState({login : true});
  } 

  render() {
    return (
      <div className="app flex-row align-items-center bg-white header-100-vh-1 font-Poppins">
      {this.renderRedirect()}
        <Container>
          <Row className="justify-content-center">
            <Col md="6">
              <Row>
                <Col className = "text-left" xs="12" sm="12" lg="6">
                  <h1> OOPS! </h1>
                  <h3> We can not seem to find the page you are looking for.</h3>
                  
                  <h6 className = "text-dark mt-4 pt-3">Error Code 404</h6>
                  <h6 className = "text-dark mb-2">Here are some useful links instead:</h6>
                  <h6><Button onClick={() => this.toggleHome()} color="link" className= "p-0 text-danger px-0">Home</Button></h6>
                  <h6><Button onClick={() => this.toggleContact()} color="link" className= "p-0 text-danger px-0">Contact Us</Button></h6>
                  <h6><Button onClick={() => this.toggleLogin()} color="link" className= "p-0 text-danger px-0">Login</Button></h6>
                </Col>
                <Col className = "d-none d-lg-block" lg ="6">
                  <img alt = "" src={logo} />
                  {/* <h6 className = "text-dark mt-4 pt-2">I think you turned the wrong way. Let's go back </h6> */}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    );
  }
}

export default Page404;



// WEBPACK FOOTER //
// ./src/views/Pages/Page404/Page404.js